import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { api, isAuthed } from '../lib/api';

const HEARTBEAT_MS = 25_000;

/** Records privacy-minimal presence while an authenticated Piixel tab is visible.
 *  The API stores only the account's last-seen timestamp. */
export default function PresenceHeartbeat() {
  const { pathname } = useLocation();

  useEffect(() => {
    let stopped = false;
    let inFlight = false;

    const beat = (): void => {
      if (stopped || inFlight || document.visibilityState !== 'visible' || !isAuthed()) return;
      inFlight = true;
      void api.presence()
        .catch(() => { /* presence must never interrupt the product */ })
        .finally(() => { inFlight = false; });
    };
    const handleVisibility = (): void => {
      if (document.visibilityState === 'visible') beat();
    };
    const handleFocus = (): void => beat();

    beat();
    const timer = window.setInterval(beat, HEARTBEAT_MS);
    document.addEventListener('visibilitychange', handleVisibility);
    window.addEventListener('focus', handleFocus);

    return () => {
      stopped = true;
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', handleVisibility);
      window.removeEventListener('focus', handleFocus);
    };
  }, [pathname]);

  return null;
}
